// extracted by mini-css-extract-plugin
export default {"subtitle":"_2cZnz","noBottomMargin":"_4bzJ8"};